// const desiredSortOrder = [
//   "Price: High to Low",
//   "Price: Low to High",
//   "Newest to Oldest",
//   "Oldest to Newest",
//   "Discount : High to Low",
//   "Relevance"
// ];
window.addEventListener('popstate', function (event) {
  // When the state changes, remove the class if the panel is not open
  if (!localStorage.getItem("wizzy-last-zip")) {
     // $("body").removeClass("wizzy-ignore-zipcode-info");
     const url = new URL(window.location.href);
  const params = url.searchParams;

  // Check if any 'product_state_tags[]' filters exist
  let shouldClean = false;

  // This removes *all* occurrences of 'product_state_tags[]'
  params.forEach((value, key) => {
    if (key === 'product_state_tags[]') {
      params.delete(key);
      shouldClean = true;
    }
  });

  if (shouldClean) {
    // Build the new URL without the unwanted params
    const newUrl =
      url.origin + url.pathname + (params.toString() ? '?' + params.toString() : '');

    // Replace the current history state with the cleaned URL
    history.replaceState(null, '', newUrl);
  }
    location.reload();
  }
});
let previousIdFlag = true;
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
    Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers
  return distance;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}
const customQueries = new Map([
  ["22 cal", true],
  ["22 mag", true],
  ["357 magnum", true],
  ["40 cal", true],
  ["9 mm", true],
  ["ammo", true],
  ["ammunition", true],
  ["ar 15", true],
  ["beretta", true],
  ["colt", true],
  ["firearm", true],
  ["firearms", true],
  ["glock", true],
  ["gun", true],
  ["guns", true],
  ["lever action", true],
  ["pistol", true],
  ["pistols", true],
  ["remington", true],
  ["revolver", true],
  ["rifle", true],
  ["rifles", true],
  ["ruger", true],
  ["shotgun", true],
  ["shotguns", true],
  ["sig ", true],
  ["sig sauer", true],
  ["smith & wesson", true],
  ["winchester", true],
]);


$("body").on("click", ".wizzy-facet-list-item", function (e) {
  let facetLabel = $(this).attr("data-term");
  window.wizzySelectedFacetValue = facetLabel;
})



// Scripts level Theme customisation goes here
const wizzyCustomUtils = {
  customTemplates: [
    "wizzy-search-results-product",
    "wizzy-search-wrapper",
    "wizzy-autocomplete-topproducts",
    "wizzy-autocomplete-wrapper",
  ],
  maxMobileScreenWidth: 768,
  isMobile() {
    return window.matchMedia(`(max-width: ${this.maxMobileScreenWidth}px)`)
      .matches;
  },
  registerWizzyEvent: function (eventName, callback) {
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents[eventName],
      function (payload = null) {
        return callback(payload);
      }
    );
  },
  changeWizzyTemplate: function (name) {
    let newDiv = document.getElementById(name + "-new").text;
    let oldDiv = document.getElementById(name);
    oldDiv.text = newDiv;
  },
  replaceAllCustomTemplates: function () {
    for (let i in this.customTemplates) {
      this.changeWizzyTemplate(this.customTemplates[i]);
    }
  },
  setOffset(payload, desktop = 1000, mobile = 1200) {
    if (
      !payload.search.configs.pagination.infiniteScrollOffset ||
      (payload.search.configs.pagination.infiniteScrollOffset &&
        typeof payload.search.configs.pagination.infiniteScrollOffset !=
          "object")
    ) {
      payload.search.configs.pagination.infiniteScrollOffset = {};
    }
    payload.search.configs.pagination.infiniteScrollOffset.desktop = desktop;
    payload.search.configs.pagination.infiniteScrollOffset.mobile = mobile;
  },
  setSearchInput(payload) {
    let searchInputIdentifiers = [];
    //Custom Logic
    // if (this.isMobile()) {
    //     searchInputIdentifiers.push(
    //         {
    //             dom:".mobile-header #Search-In-Modal-Wizzy-Mobile",
    //             type:"search"
    //         }
    //     );
    //
    // }else{
    //
    //
    //     searchInputIdentifiers.push(
    //         {
    //             dom:".desktop-header .search-modal__form .search__input",
    //             type:"search"
    //         }
    //     );
    // }
    payload.common.lazyDOMConfig.searchInputIdentifiers =
      searchInputIdentifiers;
  },
  defaultWhenScriptLoaded: function () {
    this.replaceAllCustomTemplates();
    this.attachClickEvents();
  },
  attachMutations: function () {
    this.attachHeaderMutations();
    this.attachHeaderStickyMutations();
  },
  attachHeaderStickyMutations: function () {
    let el = document.querySelector("#shopify-section-header");

    let observer = new IntersectionObserver(
      ([e]) => {
        if (e.intersectionRatio == 1) {
          $("body").removeClass("wizzyHeaderIsStick");
        } else {
          $("body").addClass("wizzyHeaderIsStick");
        }
      },
      {
        rootMargin: "-1px 0px 0px 0px",
        threshold: [0, 1],
      }
    );

    observer.observe(el);
  },
  attachHeaderMutations: function () {
    //Custom Logic
    let self = this;
    let ele = $("#wizzy-dynamic-header")[0];
    let observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if ($(mutation.target).hasClass("header--search-expanded")) {
          $("body").addClass("wizzy-search-modal-opened");
        } else {
          $("body").removeClass("wizzy-search-modal-opened");
        }
      });
    });

    observer.observe(ele, {
      attributes: true,
      attributeFilter: ["class"],
    });
  },
  whenScriptLoaded: function () {
    this.defaultWhenScriptLoaded();
    //Custom Logic
    $('[action="/search"]').attr("action", "/pages/search");
    $('[href="/search"]').removeAttr("href");
    let rootEle = document.documentElement;
    let cachedBreadCurmbs = $("#wizzy-bread-crumbs").html();
    let cachedBreadCurmbsLoaded = false;
    $(".search-bar__submit").addClass("wizzy-search-bar__submit");
    $(".wizzy-search-bar__submit").removeClass("search-bar__submit");

    if (!this.isMobile()) {
      let widthForAutocomplete = $(".search-bar").width() + 210;
      rootEle.style.setProperty(
        "--wizzy-input-width",
        widthForAutocomplete + "px"
      );
      rootEle.style.setProperty(
        "--wizzy-input-left",
        $(".search-bar").offset().left + "px"
      );
    }
    $(".header.header--inline").attr("id", "wizzy-dynamic-header");
    window.wizzyClearAll = false;
    $('body').on('click', '.wizzy-filters-clear-all', function(e) {
        window.wizzyClearAll = true;
        wizzyGeoCodeFilter.resetLocalLocations();
        // wizzyGeoCodeFilter.unselectAllAvailableLocation();
        $("body").removeClass("wizzy-hide-mobile-pincode-popup");
        wizzyGeoCodeFilter.setCurrentZip('', true);
        // wizzyGeoCodeFilter.executeFilterApi(false);

    });
    const checkValidLocalData = () => {

      // console.log(window.wizzyGeoCodeFilter, "<=====WIZZY");
        let currentZip = window.wizzyGeoCodeFilter.getCurrentZip();
        let locationIds = window.wizzyGeoCodeFilter.getLocationFromLocalStorage();

        if (currentZip && locationIds && locationIds.length) {
            return true;
        }
        window.wizzyGeoCodeFilter.resetLocalLocations();
        return false;
    }
  },
  attachClickEvents: function () {
    //Custom Logic
    let self = this;
    $("body").on("blur", ".wizzy-search-input", () => {
      $(".wizzy-search-wrapper").removeClass("mobileTapped");
      $("body").removeClass(".wizzyMobileTapped");
    });

    $("body").on("click", ".search-bar__submit", function (e) {
      $('[data-action="toggle-search"]')[0].click();
    });

    $("body").on("click", '[data-action="clear-input"]', function (e) {
      $(".search-bar__input.wizzy-search-input").val("");
      $(".search-bar__input.wizzy-search-input").removeClass("is-filled");
    });

    $("body").on("click", '[data-action="toggle-search"]', function (e) {
      if ($(".header__search-bar-wrapper").hasClass("is-visible")) {
        setTimeout((e) => {
          $(".search-bar__input.wizzy-search-input").click();
          $(".search-bar__input.wizzy-search-input").focus();
        }, 100);
      }
    });

    $("body").on(
      "click",
      ".wizzy-search-filters-top .search-filters-top-wrapper .collection__layout-button",
      function (e) {
        let targetEle = $(e.target);

        let allProducts = $(".product-item");
        if (targetEle.hasClass("is-selected")) {
        } else {
          $(".collection__layout-button.is-selected").removeClass(
            "is-selected"
          );
          setTimeout(() => {
            targetEle.addClass("is-selected");
            self.applyViewType();
          }, 10);
        }
      }
    );
    $("body").on(
      "click",
      ".wizzy-search-summary-wrapper .collection__layout-button",
      function (e) {
        let targetEle = $(e.target);

        let allProducts = $(".product-item");
        if (targetEle.hasClass("is-selected")) {
        } else {
          $(".collection__layout-button.is-selected").removeClass(
            "is-selected"
          );
          setTimeout(() => {
            targetEle.addClass("is-selected");
            self.applyViewType();
          }, 10);
        }
      }
    );
    $("body").on("submit", "#wizzy__quickview__addtocart__form", function (e) {
      e.preventDefault();
      let formElement = $(e.target);
      let submitBtn = formElement.find('[type="submit"]');
      submitBtn.attr("disabled");

      let productVariantId = formElement.find('[name="id"]').val();
      let productQt = 1;
      let productData = {
        items: [
          {
            quantity: productQt,
            id: productVariantId,
          },
        ],
      };
      let updateCart = window.origin + "/cart?view=mini-cart";
      fetch(window.routes.cartAddUrl + ".js", {
        body: JSON.stringify(productData),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
        },
      })
        .then(function (response) {
          if (response.ok) {
            document.dispatchEvent(
              new CustomEvent("product:added", {
                bubbles: true,
                detail: {
                  variant: null,
                  quantity: parseInt(productQt),
                },
              })
            );

            fetch(updateCart)
              .then(function (response) {
                return response.text();
              })
              .then((res) => {
                $("#mini-cart").html(res);
                let currentCount = parseInt(
                  $(".header__action-item--cart .header__cart-count").text()
                );
                $(".header__action-item--cart .header__cart-count").text(
                  currentCount + 1
                );
                $('[data-action="toggle-mini-cart"]')[0].click();
                submitBtn.removeAttr("disabled");
              });
          } else {
            submitBtn.attr("disabled");
          }
        })
        .catch(function (error) {
          submitBtn.attr("disabled");
          submitBtn.text("out of stock");
        });
    });
    $("body").on(
      "submit",
      '.wizzy-search-results [action="/cart/add"]',
      function (e) {
        e.preventDefault();
        let formElement = $(e.target);
        let submitBtn = formElement.find('[type="submit"]');
        submitBtn.attr("disabled");

        let productVariantId = formElement.find('[name="id"]').val();
        let productQt = 1;
        let productData = {
          items: [
            {
              quantity: productQt,
              id: productVariantId,
            },
          ],
        };
        let updateCart = window.origin + "/cart?view=mini-cart";
        fetch(window.routes.cartAddUrl + ".js", {
          body: JSON.stringify(productData),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
          },
        })
          .then(function (response) {
            if (response.ok) {
              document.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: {
                    variant: null,
                    quantity: parseInt(productQt),
                  },
                })
              );

              fetch(updateCart)
                .then(function (response) {
                  return response.text();
                })
                .then((res) => {
                  $("#mini-cart").html(res);
                  let currentCount = parseInt(
                    $(".header__action-item--cart .header__cart-count").text()
                  );
                  $(".header__action-item--cart .header__cart-count").text(
                    currentCount + 1
                  );
                  $('[data-action="toggle-mini-cart"]')[0].click();
                  submitBtn.removeAttr("disabled");
                });
            } else {
              submitBtn.attr("disabled");
            }
          })
          .catch(function (error) {
            submitBtn.attr("disabled");
            submitBtn.text("out of stock");
          });
      }
    );

    $("body").on("click", "#wizzy-custom-filter-button", function (e) {
      $(".wizzy-filters-mobile-entry")[0].click();
    });
    $("body").on("click", "#wizzy-custom-sorty-by-button", function (e) {
      $(".wizzy-common-select-selector").click();
    });
    $("body").on('click', ".wizzy-no-store-all-inventory", function(e) {
      $('body').addClass("wizzy-ignore-zipcode-info");
      window.wizzyConfig.pageStore.hasMoreResults = true;
    });


    $("body").on("click", ".wizzy-no-store-found-data-elements", function(e) {
      let base = [
          window.location.origin,
          window.location.pathname
      ].join('');

      let filterValue = $(this).attr("data-filter-term");
      let searchKey = window.wizzyConfig.pageStore.searchedResponse.filters.searchedKey
      let q = window.wizzyConfig.pageStore.searchSubmitValue;

      let qString = '';
      if (q && q.length) {
          qString = "&q=" + q;
      }


      //let filterUrl = [base, `attributeFacetValuesLimit=50&currency=USD&getAllVariants=false&page=1&product_city_tags[]=${filterValue}&productsCount=20${qString}&searchedKey=${searchKey}&showOOSProductsInOrder=false&sort_field[]=product_value_tags_image_based_sort_ruled_based_bt%3Afloat&sort_field[]=relevance&sort_order[]=asc&sort_order[]=asc&type=DEFAULT`].join('?');

      let filterUrl = [base, `attributeFacetValuesLimit=600&currency=USD&getAllVariants=false&page=1&product_state_tags[]=${filterValue}&productsCount=20&categories[]=all&showOOSProductsInOrder=false&sort_field[]=product_value_tags_image_based_sort_ruled_based_bt%3Afloat&sort_field[]=relevance&sort_order[]=asc&sort_order[]=asc&type=DEFAULT`].join('?');

      window.executeWizzyFiltersFromURL(filterUrl);
      window.wizzyConfig.pageStore.hasMoreResults = true;
      $("body").addClass("wizzy-ignore-zipcode-info");
      
    });
    $("body").on('click', ".wizzy-popup-close", function(e) {
       $(".wizzy-no-pincode").css("display", "none");
      $("html").removeClass("wizzy-scroll-disabled");
    });
    $("body").on('click',".wizzy-available-stores-apply-button", function(e) {
      // console.log("click attached");
        let targetEle = $(e.target);
        let form = $(targetEle).closest('form');
        let currentInput = form.find('input[name="wizzy-zip"]');
        if(currentInput.length > 0) {
          // console.log("inner condition")
           let currentInputValue = currentInput[0].value;
          // console.log("currentInputValue : ",currentInputValue);
          // console.log("currentInputValue : ",currentInputValue.length);
            if ((typeof currentInputValue !== 'undefined' || currentInputValue !== NaN || currentInputValue !== null) && currentInputValue.length === 5) {
              $("html").removeClass("wizzy-scroll-disabled");
            }
        }
    });
    $("body").on('click', ".wizzy-custom-store-location-filter .wizzy-available-store-wrpper", function(e) {
      // console.log("Click event applied to locations");
       const applyButton = document.querySelector(".wizzy-available-stores-apply-button");
      if (applyButton) {
        setTimeout(function() { applyButton.click(); }, 400);
      }
    });

    $("body").on('click',".search-bar__input-clear",function(e) {
     window.location.href = "https://shop.ezpawn.com/collections/all";
    })

    $("body").on('click',".wizzy-back-to-collection",function(e) {
      if(window.wizzyConfig.common.isOnCategoryPage) {
        window.location.href = "https://shop.ezpawn.com" + window.wizzyConfig.common.categoryEndpoint; 
      }
    })
  },

  beforeSearch: function () {
    let self = this;
    self.registerWizzyEvent("BEFORE_SEARCH_EXECUTED", (payload) => {
      self.addSecondLevelSorting(payload, "BEFORE_SEARCH_EXECUTED");
      payload.attributeFacetValuesLimit = 600;

       payload.facets.push({
          "label": "Location IDS",
          "key": "product_inventory_sources_ids",
          "position": "left",
          "order": 4
      });
      return payload;
    });
  },
  beforeAutoComplete() {
    let self = this;
    self.registerWizzyEvent("BEFORE_AUTOCOMPLETE_EXECUTED", (payload) => {
      self.addSecondLevelSorting(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      let inventoryIds = localStorage.getItem("wizzy_product_inventory_sources_ids");
      if (inventoryIds != "[]" && inventoryIds != null) {
        let inventoryIdsArray = JSON.parse(inventoryIds);
        let mapped = inventoryIdsArray.map(value => ({
          key: value,
          inStock: [true]
        }));
        let data = JSON.stringify(mapped);
        // console.log("from autocomplete inventoryIds : ",data);
        payload.inventorySources = data;
      }
      return payload;
    });
  },
  beforeAutocompleteWrapperRender() {
    let self = this;
    self.registerWizzyEvent("BEFORE_AUTOCOMPLETE_WRAPPER_RENDER", (payload) => {
      let q = window.wizzyConfig.pageStore.searchInputValue;
      if (customQueries.get(q.toLowerCase())) {
        payload.showCustomAutocomplete = true;
      } else {
        payload.showCustomAutocomplete = false;
      }
      return payload;
    });
  },
  beforeFilter: function () {
    let self = this;
    self.registerWizzyEvent("BEFORE_FILTERS_EXECUTED", (payload) => {
            if (typeof payload.filters.facets.push == "function") {
          payload.filters.facets.push({
              "label": "Location IDS",
              "key": "product_inventory_sources_ids",
              "position": "left",
              "order": 3
          });
      }
      if (window.wizzyConfig.common.isOnCategoryPage) {
        payload.filters.includeCategoriesFacetForPage = true;
      }
      const productCityTag = payload?.filters?.attributes?.product_city_tags;

          if (Array.isArray(productCityTag) && productCityTag.length > 0 && previousIdFlag) {
             const elements = $('[data-key="product_inventory_sources_ids"] [data-term]').toArray();
             window.wizzyGeoCodeFilter.previousInventoryIds = elements;           
             previousIdFlag = false;
            // window.localStorage.setItem('wizzy_inventory_sources', JSON.stringify(elements));
            // console.log("Stores stored");
          } else if (Array.isArray(productCityTag) && productCityTag.length == 0) {
              const elements = $('[data-key="product_inventory_sources_ids"] [data-term]').toArray();
              window.wizzyGeoCodeFilter.previousInventoryIds = elements;
              previousIdFlag = true;
          }
      self.addSecondLevelSorting(payload, "BEFORE_FILTERS_EXECUTED");
      payload.filters.attributeFacetValuesLimit = 600;
      return payload;
    });
  },
  beforeRenderResults: function () {
    let self = this;
    self.registerWizzyEvent("BEFORE_RENDER_RESULTS", (payload) => {
      if (!window.wizzyConfig.common.isOnCategoryPage) {
        self.sortFilterValues(payload, "BEFORE_RENDER_RESULTS");
      }

      if (payload.api === "search") {
        // console.log("IN SEARCH API");
        let q = window.wizzyConfig.pageStore.searchInputValue;
        if (window.wizzyConfig.common.isOnCategoryListing !== true) {
          if (customQueries.get(q.toLowerCase())) {
            window.wizzyConfig.common.templateSettings = true;
          } else {
            window.wizzyConfig.common.templateSettings = false;
          }
        } else {
          window.wizzyConfig.common.templateSettings = false;
        }
      } else {
        window.wizzyConfig.common.templateSettings = false;
      }
      return payload;
    });
  },
  beforeInit: function () {
    let self = this;
    this.registerWizzyEvent("BEFORE_INIT", (payload) => {
      self.setOffset(payload, 1500, 1500);
      //self.setSearchInput(payload);
      if(window.wizzyConfig.common.isOnCategoryPage) {
        payload.common.lazyDOMConfig.contentDOMIdentifiers = ["#wizzy-shopify-collection-page-wrapper"];  
      }else {
        payload.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];  
      }
      payload.search.configs.facets.configs.push({
        "label": "States",
        "key": "product_state_tags",
        "position": "left",
        "order": 5
      });
      
      payload.search.configs.general.minQueryLength = 1;
      payload.endpoints.common = "https://miranda-api.wizsearch.in";
      //Custom Logic
      // window?.wizzyConfig?.search?.configs?.sorts?.configs.sort((a, b) => {
      //   return desiredSortOrder.indexOf(a.label) - desiredSortOrder.indexOf(b.label);
      // });
      return payload;
    });
  },
  afterTransform: function () {
    let self = this;
    self.registerWizzyEvent("AFTER_PRODUCTS_TRANSFORMED", (productList) => {
      productList = productList.map((x) => {
        //Custom Logic
        x.mainImageSet = self.getIamgesSet(x.mainImage);
        x.hoverImageSet = self.getIamgesSet(x.hoverImage);
        return x;
      });
       productList.forEach((x) => {
            let attributes = x.attributes;
            let foundLocationName=attributes.filter(x=>x.id=="product_inventory_sources")[0]?.values[0]?.value[0];
            let foundLocationId=attributes.filter(x=>x.id=="product_inventory_sources_ids")[0]?.values[0]?.value[0];
            // x.foundStoreName = foundLocationName;
            // console.log("From AFTER_PRODUCTS_TRANSFORMED found location name : ",foundLocationName);
            // let fromLocation = zipcodeLatLon["78206"];
            let zipLatitude = window.localStorage.zipLatitude; 
            let zipLongitude = window.localStorage.zipLongitude; 
            // console.log("Zipcode lat long",fromLocation);
            let toLocation = window.wizzyGeoCustomLocations[foundLocationId];
            if (zipLatitude && zipLongitude && toLocation) {
                const distance = getDistanceFromLatLonInKm(
                  zipLatitude, zipLongitude,
                  toLocation.latitude, toLocation.longitude
                );
              x.distanceLatLon = (distance*0.621371).toFixed(1); // Convert distance in miles
              x.foundStoreName = toLocation.name;
            }
            
            // let foundLocationId=attributes.filter(x=>x.id=="product_inventory_sources_ids");
            // if (foundLocationName.length && foundLocationId.length) {
            //   let locationId=foundLocationId[0].values[0].value
            //   let locationName=foundLocationName[0].values[0].value;
            //   if (!allLocations.hasOwnProperty(locationId)) {
            //     allLocations[locationId]={
            //                                 'id':locationId[0],
            //                                 'name':locationName[0],
            //                                 "latitude": "",
            //                                 "longitude": ""
            //                               }
            //       ;
            //   }
            // }

            return x;
        });
      if (productList.length < 3) {
        $("body").addClass("wizzyMinResult");
      } else {
        $("body").removeClass("wizzyMinResult");
      }

      return productList;
    });
  },
  HandleZipCodeAndRadius(payload) {
    if(window.wizzyGeoCodeFilter) {
      window.wizzyGeoCodeFilter.init();
      window.wizzyGeoCodeFilter.makeApiCall();
    }
  },
  updateDomBeforeZipCodeResults() {
    let x = document.querySelector(".wizzy-search-wrapper");
    x.innerHTML = `<div class="wizzy-skeleton-wrapper wizzy-progress-container">
        <div class="wizzy-skeleton-container">
            <div class="wizzy-skeleton-summary-and-sort">
              <span class="wizzy-skeleton-summary wizzy-skeleton-style"> </span>
              <span class="wizzy-skeleton-sort wizzy-skeleton-style"> </span>
            </div>

            <div class="wizzy-skeleton-product-filters">
              <div class="wizzy-skeleton-results-filters">
                <span class="wizzy-skeleton-results-filters-header wizzy-skeleton-style"> </span>
                <div class="wizzy-skeleton-results-filters-block">
                  <span class="wizzy-skeleton-results-filters-item-head wizzy-skeleton-style"> </span>
                  <span class="wizzy-skeleton-results-filters-item wizzy-skeleton-results-filters-item-1 wizzy-skeleton-style">
                  </span>
                  <span class="wizzy-skeleton-results-filters-item wizzy-skeleton-results-filters-item-2 wizzy-skeleton-style">
                  </span>
                  <span class="wizzy-skeleton-results-filters-item wizzy-skeleton-results-filters-item-3 wizzy-skeleton-style">
                  </span>
                </div>
                <div class="wizzy-skeleton-results-filters-block">
                  <span class="wizzy-skeleton-results-filters-item-head wizzy-skeleton-style"> </span>
                  <span class="wizzy-skeleton-results-filters-item wizzy-skeleton-results-filters-item-1 wizzy-skeleton-style">
                  </span>
                  <span class="wizzy-skeleton-results-filters-item wizzy-skeleton-results-filters-item-2 wizzy-skeleton-style">
                  </span>
                </div>
              </div>

              <div class="wizzy-skeleton-results-list">
                
                    <div class="wizzy-skeleton-result-product">
                        <div class="wizzy-skeleton-result-product-image wizzy-skeleton-style"></div>
                        <div class="wizzy-skeleton-result-product-info">
                            <span class="wizzy-skeleton-result-product-title wizzy-skeleton-style"> </span>
                            <div class="wizzy-skeleton-result-product-price">
                            <span class="wizzy-skeleton-result-product-discounted-price wizzy-skeleton-style"> </span>
                            <span class="wizzy-skeleton-result-product-regular-price wizzy-skeleton-style"> </span>
                            </div>
                        </div>
                    </div>
                
                    <div class="wizzy-skeleton-result-product">
                        <div class="wizzy-skeleton-result-product-image wizzy-skeleton-style"></div>
                        <div class="wizzy-skeleton-result-product-info">
                            <span class="wizzy-skeleton-result-product-title wizzy-skeleton-style"> </span>
                            <div class="wizzy-skeleton-result-product-price">
                            <span class="wizzy-skeleton-result-product-discounted-price wizzy-skeleton-style"> </span>
                            <span class="wizzy-skeleton-result-product-regular-price wizzy-skeleton-style"> </span>
                            </div>
                        </div>
                    </div>
                
                    <div class="wizzy-skeleton-result-product">
                        <div class="wizzy-skeleton-result-product-image wizzy-skeleton-style"></div>
                        <div class="wizzy-skeleton-result-product-info">
                            <span class="wizzy-skeleton-result-product-title wizzy-skeleton-style"> </span>
                            <div class="wizzy-skeleton-result-product-price">
                            <span class="wizzy-skeleton-result-product-discounted-price wizzy-skeleton-style"> </span>
                            <span class="wizzy-skeleton-result-product-regular-price wizzy-skeleton-style"> </span>
                            </div>
                        </div>
                    </div>
                
                    <div class="wizzy-skeleton-result-product">
                        <div class="wizzy-skeleton-result-product-image wizzy-skeleton-style"></div>
                        <div class="wizzy-skeleton-result-product-info">
                            <span class="wizzy-skeleton-result-product-title wizzy-skeleton-style"> </span>
                            <div class="wizzy-skeleton-result-product-price">
                            <span class="wizzy-skeleton-result-product-discounted-price wizzy-skeleton-style"> </span>
                            <span class="wizzy-skeleton-result-product-regular-price wizzy-skeleton-style"> </span>
                            </div>
                        </div>
                    </div>
                
                    <div class="wizzy-skeleton-result-product">
                        <div class="wizzy-skeleton-result-product-image wizzy-skeleton-style"></div>
                        <div class="wizzy-skeleton-result-product-info">
                            <span class="wizzy-skeleton-result-product-title wizzy-skeleton-style"> </span>
                            <div class="wizzy-skeleton-result-product-price">
                            <span class="wizzy-skeleton-result-product-discounted-price wizzy-skeleton-style"> </span>
                            <span class="wizzy-skeleton-result-product-regular-price wizzy-skeleton-style"> </span>
                            </div>
                        </div>
                    </div>
                
                    <div class="wizzy-skeleton-result-product">
                        <div class="wizzy-skeleton-result-product-image wizzy-skeleton-style"></div>
                        <div class="wizzy-skeleton-result-product-info">
                            <span class="wizzy-skeleton-result-product-title wizzy-skeleton-style"> </span>
                            <div class="wizzy-skeleton-result-product-price">
                            <span class="wizzy-skeleton-result-product-discounted-price wizzy-skeleton-style"> </span>
                            <span class="wizzy-skeleton-result-product-regular-price wizzy-skeleton-style"> </span>
                            </div>
                        </div>
                    </div>
                
                    <div class="wizzy-skeleton-result-product">
                        <div class="wizzy-skeleton-result-product-image wizzy-skeleton-style"></div>
                        <div class="wizzy-skeleton-result-product-info">
                            <span class="wizzy-skeleton-result-product-title wizzy-skeleton-style"> </span>
                            <div class="wizzy-skeleton-result-product-price">
                            <span class="wizzy-skeleton-result-product-discounted-price wizzy-skeleton-style"> </span>
                            <span class="wizzy-skeleton-result-product-regular-price wizzy-skeleton-style"> </span>
                            </div>
                        </div>
                    </div>
                
                    <div class="wizzy-skeleton-result-product">
                        <div class="wizzy-skeleton-result-product-image wizzy-skeleton-style"></div>
                        <div class="wizzy-skeleton-result-product-info">
                            <span class="wizzy-skeleton-result-product-title wizzy-skeleton-style"> </span>
                            <div class="wizzy-skeleton-result-product-price">
                            <span class="wizzy-skeleton-result-product-discounted-price wizzy-skeleton-style"> </span>
                            <span class="wizzy-skeleton-result-product-regular-price wizzy-skeleton-style"> </span>
                            </div>
                        </div>
                    </div>
                
              </div>
            </div>
        </div>
    </div>`;
  },
  pageRendered: false,
  isLocationLoaded: false,
  viewRendered: function () {
    let self = this;
    this.registerWizzyEvent("VIEW_RENDERED", (payload) => {
      //Custom Logic

      let facetScrollId = setInterval(function() {
        if(window.wizzySelectedFacetValue) {
          let x = document.querySelector(".wizzy-facet-list-item[title=\"" + window.wizzySelectedFacetValue + "\"]");
          // console.log(window.wizzySelectedFacetValue, "<====values");
          window.wizzySelectedFacetValue = null;
          if(x) {
            setTimeout(function() { x.scrollIntoView({"behavior": "smooth", "block": "center"}) }, 800);
          }
          clearInterval(facetScrollId);
        }
      }, 40);

      setTimeout(function() {
        // console.log("<======clear by abcd");
        clearInterval(facetScrollId);
      }, 2000);
      

      if(payload.data.api === "filter") {
        window.wizzySelectedFacetTrue = true;
      }
      
      // let zipCode = window.localStorage.getItem("wizzy-last-zip");
      // console.log("TYPE ZIP => ", zipCode, typeof zipCode);
      
      
      // if(typeof zipCode !== 'undefined' && zipCode !== null && !self.isLocationLoaded && payload.data.api === "filter") {
      //   self.isLocationLoaded = true;
      //   self.updateDomBeforeZipCodeResults();
      //   self.HandleZipCodeAndRadius(payload);
      // }else if(typeof zipCode !== 'undefined' && zipCode !== null && payload.data.api === "search") {
      //   self.isLocationLoaded = true;
      //   self.updateDomBeforeZipCodeResults();
      //   self.HandleZipCodeAndRadius(payload);
      // }

      let searchOrFilter = ["search", "filter"];
      if(typeof window.wizzyPincodeApplyButtonClicked !== 'undefined' && window.wizzyPincodeApplyButtonClicked === true) {
          window.wizzyPincodeApplyButtonClicked = false;
          let filterApplyButton = document.querySelector(".wizzy-mobile-apply-filter-wrapper");
          if(filterApplyButton) {
              filterApplyButton.click();  
          }  
      }
      if (payload.data.api == "search" || payload.data.api == "filter") {
            window.wizzyGeoCodeFilter.init();
      }

       if (payload.data.api == "filter" && !self.isLocationLoaded && window.wizzyConfig.common.isOnCategoryPage && window.location.search.length === 0) {
          self.isLocationLoaded = true;
          // window.wizzyGeoCodeFilter.makeApiCall();
          setTimeout(function() {
            if(!((window.location.pathname == "/collections/tampa" && window.location.search == "")|| (window.location.pathname == "/collections/houston" && window.location.search == "")|| (window.location.pathname == "/collections/dallas" && window.location.search == "") || (window.location.pathname == "/collections/miami" && window.location.search == "") || (window.location.pathname == "/collections/san-antonio" && window.location.search == ""))) {
              window.wizzyGeoCodeFilter.executeFilterApi(false);
              // console.log("Geocode filter api called");
            }
          }, 500);
      }

      if (payload.data.api == "search" || payload.data.api == "filter") {

            if (payload.data.api =="search") {
              window.wizzyGeoCodeFilter.executeFilterApi(false);
            }

            // console.log(wizzyGeoCodeFilter.getCurrentZip(), "<=======ABBBBBBBBBBBBBBBBBBBBBBBBBBBBB");
        
            if (window.wizzyGeoCodeFilter.getCurrentZip() && window.wizzyGeoCodeFilter.getCurrentZip().length == 5) {
                $("body").removeClass("wizzy-dont-have-pincode");
                $("body").addClass("wizzy-have-pincode");
            } else {
                // console.log("Class added");
                $("body").addClass("wizzy-dont-have-pincode");
                $("body").removeClass("wizzy-have-pincode");
            }

  //  console.log(payload.data.response.payload.filters?.attributes?.hasOwnProperty('product_inventory_sources_ids'));
            // payload.data.api !== "search" &&
            if ((!payload.data.response.payload.filters?.attributes?.hasOwnProperty('product_inventory_sources_ids') || typeof payload.data.response.payload.filters?.attributes === "undefined")) {
                  // console.log("inside if condition");
                  let allTheFacets = payload.data.response.payload.facets;
                  let allTheFacetsLen = allTheFacets.length;
                  let dataToShowOnPage = [  "Texas",
                                            "Tennessee",
                                            "Alabama",
                                            "Pennsylvania",
                                            "Georgia",
                                            "Arizona",
                                            "Oregon",
                                            "Illinois",
                                            "Iowa",
                                            "Indiana",
                                            "Colorado",
                                            "Oklahoma",
                                            "Florida",
                                            "Wisconsin",
                                            "Minnesota",
                                            "Nevada",
                                            "Mississippi",
                                            "Arkansas",
                                            "Utah"
                                          ];
                
                  // for(let i = 0 ; i < allTheFacetsLen ; i++) {
                  //   if(allTheFacets[i].key === "product_city_tags") {
                  //     let cityLen = allTheFacets[i].data.length;
                  //     for(let j = 0 ; j < cityLen; j++) {
                  //       dataToShowOnPage.push(allTheFacets[i].data[j].label);
                  //     }
                  //   }
                  // }
                  
                  if(dataToShowOnPage.length > 0) {
                    // console.log("inside data condition");
                    let domToGive = document.querySelector(".wizzy-no-store-found-data-to-add-wrapper");

                    if(domToGive && domToGive.childNodes.length === 0) {
                      dataToShowOnPage.forEach(function(item) {
                        let anchorTagEle = document.createElement('a');
                        anchorTagEle.style.color = "#007DB3";
                        anchorTagEle.style.textDecoration = "underline";
                        anchorTagEle.style.display = "block";
                        anchorTagEle.style.cursor = 'pointer';
                        anchorTagEle.style.width = 'max-content';
                        anchorTagEle.innerHTML = item;
                        anchorTagEle.setAttribute("data-filter-term", item.toLowerCase());
                        // console.log("state : ",item.toLowerCase());
                        anchorTagEle.classList.add("wizzy-no-store-found-data-elements");
    
                        domToGive.appendChild(anchorTagEle);
                      });  
                    }
                    
                  }
              
                $("body").addClass("wizzy-has-not-available-stores");
                $("body").removeClass("wizzy-has-available-stores");
                $("body").removeClass("wizzy-hide-no-store-found");

            } else {
              if(payload.data.response.payload.filters?.attributes?.hasOwnProperty('product_inventory_sources_ids')) {
                
                $("body").addClass("wizzy-has-available-stores");
                $("body").removeClass("wizzy-has-not-available-stores");
                $("body").addClass("wizzy-hide-no-store-found");
                if(document.documentElement.clientWidth < 768) {
                  $("body").addClass("wizzy-hide-mobile-pincode-popup");
                }
              }else {
                $("body").addClass("wizzy-has-available-stores");
                $("body").removeClass("wizzy-has-not-available-stores");
                $("body").addClass("wizzy-hide-no-store-found");
              }
                
            }

        }

      if (
        window.wizzyConfig.search.configs.general.noOfProducts > payload.total
      ) {
        $("body").addClass("wizzyWithoutShorting");
      } else {
        $("body").removeClass("wizzyWithoutShorting");
      }
      if (!cachedBreadCurmbsLoaded) {
        cachedBreadCurmbsLoaded = true;
        $(".wizzy-search-summary-wrapper .wizzy-search-summary-container").html(
          cachedBreadCurmbs
        );
      }
      // console.log("uuu -- shrey")
      if (searchOrFilter.includes(payload.data.api)) {
        let localType = localStorage.getItem("wizzy_view_type");
        if (localType && !self.pageRendered) {
          let isSelectedEle = '[data-layout-mode="' + localType + '"]';
          $(isSelectedEle).click();
          self.pageRendered = true;
        }
        self.applyViewType();
      }
      if(window.wizzyConfig.common.isOnCategoryPage && payload.data.api === "filter" && payload.data.response.payload.result.length == 0 ) {
        const backButton = document.querySelector(".wizzy-back-to-collection-wrapper");
        if(backButton) backButton.style.display = "block";
      }
            
      return payload;
    });
  },
  customFunctionToAddCookieGivenByClient() {
    try {
      var wishlistButtons = document.querySelectorAll(
        ".wizzy-search-results .swym-add-to-wishlist-view-product:not(.wizzy-cookie-listener)"
      );
      if (wishlistButtons) {
        wishlistButtons.forEach(function (button) {
          if (!button.classList.contains("wizzy-cookie-listener")) {
            button.classList.add("wizzy-cookie-listener");
            button.addEventListener("click", function (event) {
              event.preventDefault();
              var productUrl = button.getAttribute("data-product-url");
              document.cookie =
                "WLproductUrl=" + encodeURIComponent(productUrl) + "; path=/";
            });
          }
        });
      }
    } catch (error) {
      console.log(error, "<====error");
    }
  },
  productsResultsRendered: function () {
    let self = this;
    self.registerWizzyEvent("PRODUCTS_RESULTS_RENDERED", (data) => {

      // let facetScrollId = setInterval(function() {
      //   // console.log(window.wizzySelectedFacetValue, "<======facetScrollId");
      //   if(window.wizzySelectedFacetValue) {
      //     let x = document.querySelector(".wizzy-facet-list-item[title=\"" + window.wizzySelectedFacetValue + "\"]");
      //     // console.log(x, "<======X");
      //     window.wizzySelectedFacetValue = null;
      //     if(x) {
      //       setTimeout(function() { x.scrollIntoView({"block": "center"}) }, 800);
      //     }
      //     clearInterval(facetScrollId);
      //   }
      // }, 50);

      // setTimeout(function() {
      //   // console.log("<======clear by abcd");
      //   clearInterval(facetScrollId);
      // }, 5000);
  
      
      // if (window._swat) {
      //   window._swat.initializeActionButtons(".wizzy-search-results");
      // }
      self.customFunctionToAddCookieGivenByClient();
      setTimeout(function() {
        let body = document.querySelector("body");
        let noStoreFound = document.querySelector(".wizzy-no-store-found-stores");
        if(noStoreFound && !body.classList.contains("wizzy-ignore-zipcode-info")) {
          let cssObj = window.getComputedStyle(noStoreFound, null);
          if(cssObj.display === 'block') {
            window.wizzyConfig.pageStore.hasMoreResults = false;    
          }
        }  
      }, 500);
      return data;
    });
  },
  cacheResultRendered: function () {
    let self = this;
    self.registerWizzyEvent("PRODUCTS_CACHED_RESULTS_RENDERED", (data) => {
      self.isLocationLoaded = true;
      //Custom Logic
      if (window._swat && window._swat.ui) {
        window._swat.initializeActionButtons(".wizzy-search-results");
      }
      window.wizzyGeoCodeFilter.init();
      if (wizzyGeoCodeFilter.getCurrentZip() && wizzyGeoCodeFilter.getCurrentZip().length == 5) {
            $("body").removeClass("wizzy-dont-have-pincode");
            $("body").addClass("wizzy-have-pincode");
            if (location.pathname.includes('/collections/store_') || location.pathname.includes('/collections/Store_')) {
              let allInvetBtn = document.querySelector(".wizzy-no-store-all-inventory");
              if (allInvetBtn) {
                  allInvetBtn.click();
              }
            }
        } else {
            $("body").addClass("wizzy-dont-have-pincode");
            if ($('body').hasClass('wizzy-ignore-zipcode-info')) {
                  $("html").removeClass("wizzy-scroll-disabled");
                }else {
                  $("html").addClass("wizzy-scroll-disabled");
                }
            if (location.pathname.includes('/collections/store_') || location.pathname.includes('/collections/Store_')) {
                  let allInvetBtn = document.querySelector(".wizzy-no-store-all-inventory");
                  if (allInvetBtn) {
                      allInvetBtn.click();
                  }
                }
                if (location.search.includes("product_market_tags[]=") || location.search.includes("product_category_tags[]=")) {
              const viewAllInventory = document.querySelector(".wizzy-no-store-all-inventory");
              if(viewAllInventory)  viewAllInventory.click();
            }
            $("body").removeClass("wizzy-have-pincode");
        }
      let params = new URLSearchParams(document.location.search);
      if (params.get("product_inventory_sources_ids[]") !== null) {
            $('body').addClass('wizzy-has-available-stores');
            $('body').addClass('wizzy-hide-no-store-found');
            $('body').removeClass('wizzy-has-not-available-stores');
        } else {
            $('body').removeClass('wizzy-has-available-stores');
            $('body').addClass('wizzy-has-not-available-stores');
            $('body').removeClass('wizzy-hide-no-store-found');

            if(window.wizzyConfig.pageStore.searchedResponse) {
              
              let allTheFacets = window.wizzyConfig.pageStore.searchedResponse.facets;
              let allTheFacetsLen = allTheFacets.length;
              // let dataToShowOnPage = [
              //                           "Texas",
              //                           "Tennessee",
              //                           "Alabama",
              //                           "Pennsylvania",
              //                           "Georgia",
              //                           "Arizona",
              //                           "Oregon",
              //                           "Illinois",
              //                           "Iowa",
              //                           "Indiana",
              //                           "Colorado",
              //                           "Oklahoma",
              //                           "Florida",
              //                           "Wisconsin",
              //                           "Minnesota",
              //                           "Nevada",
              //                           "Mississippi",
              //                           "Arkansas",
              //                           "Utah"
              //                         ];
              let dataToShowOnPage = [];
                
                  for(let i = 0 ; i < allTheFacetsLen ; i++) {
                    if(allTheFacets[i].key === "product_state_tags") {
                      let cityLen = allTheFacets[i].data.length;
                      for(let j = 0 ; j < cityLen; j++) {
                        dataToShowOnPage.push(allTheFacets[i].data[j].label);
                      }
                    }
                  }
            
              // for(let i = 0 ; i < allTheFacetsLen ; i++) {
              //   if(allTheFacets[i].key === "product_city_tags") {
              //     let cityLen = allTheFacets[i].data.length;
              //     for(let j = 0 ; j < cityLen; j++) {
              //       dataToShowOnPage.push(allTheFacets[i].data[j].label);
              //     }
              //   }
              // }
              dataToShowOnPage.sort((a, b) => a.localeCompare(b));
              if(dataToShowOnPage.length > 0) {
                let domToGive = document.querySelector(".wizzy-no-store-found-data-to-add-wrapper");
  
                if(domToGive && domToGive.childNodes.length === 0) {
                  dataToShowOnPage.forEach(function(item) {
                    let anchorTagEle = document.createElement('a');
                    anchorTagEle.style.color = "#03baba";
                    anchorTagEle.style.textDecoration = "underline";
                    anchorTagEle.style.display = "block";
                    anchorTagEle.style.cursor = 'pointer';
                    anchorTagEle.style.width = 'max-content';
                    anchorTagEle.innerHTML = item;
                    anchorTagEle.setAttribute("data-filter-term", item.toLowerCase());
                    anchorTagEle.classList.add("wizzy-no-store-found-data-elements");
  
                    domToGive.appendChild(anchorTagEle);
                  });  
                }
                
              }
            }
          
        }
      $("body").addClass("wizzy-search-results-rendered");
      return data;
    });
  },
  afterFilterItemClicked: function () {
    let self = this;
    self.registerWizzyEvent("AFTER_FILTER_ITEM_CLICKED", (data) => {
      // console.log(data, "<=====After Filter Item Clicked");

      window.wizzySelectedFacetValue = data.facetLabel;

      
      return data;
    })
  },
  init: function () {
    let wizzyCustomInitProcess = [
      "whenScriptLoaded",
      "attachMutations",
      "beforeInit",
      "beforeSearch",
      "beforeAutoComplete",
      "beforeAutocompleteWrapperRender",
      "beforeFilter",
      "afterTransform",
      "beforeRenderResults",
      // "viewRendered",
      "productsResultsRendered",
      "cacheResultRendered",
      "afterFilterItemClicked",
    ];
    try {
      for (let i in wizzyCustomInitProcess) {
        if (typeof this[wizzyCustomInitProcess[i]] == "function") {
          this[wizzyCustomInitProcess[i]]();
        }
      }
    } catch (error) {
      console.log("=======>", error);
    }
  },

  applyViewType: function () {
    let allProducts = $(".wizzy-search-wrapper .product-item");
    let targetEle = $(
      ".wizzy-search-filters-top .collection__layout-button.is-selected"
    );
    let type = targetEle.attr("data-layout-mode");
    if (!type) {
      targetEle = $(
        ".wizzy-search-summary-wrapper .collection__layout-button.is-selected"
      );

      type = targetEle.attr("data-layout-mode");
    }

    localStorage.setItem("wizzy_view_type", type);

    switch (targetEle.attr("data-layout-mode")) {
      case "list":
        allProducts.removeClass(
          "product-item--vertical 1/3--tablet-and-up 1/4--desk"
        );
        allProducts.addClass("product-item--list");

        break;

      case "grid":
        allProducts.removeClass("product-item--list");
        allProducts.addClass(
          "product-item--vertical 1/3--tablet-and-up 1/4--desk"
        );
        break;
    }
  },
  getIamgesSet: function (url) {
    if (!url) return;
    let imageSet = [];
    let sizes = [200, 300, 400, 500, 600, 700, 800];

    sizes.forEach((x) => {
      imageSet.push(url.replaceAll("_360x.", "_" + x + ".") + " " + x + "w");
    });

    return imageSet.join(",");
  },
  sortFilterValues: function (payload, type) {
    let facets = payload.response.payload.facets;
    for (let i in facets) {
      let facet = facets[i];
      if (facet.type != "range" && facet.key == "categories") {
        facet.data = facet.data.sort(function (a, b) {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        });
      }
    }
  },
  addSecondLevelSorting: function (payload, forEvent = "") {
    let fieldKey = "product_value_tags_image_based_sort_ruled_based_bt:float";
    let customSort = {
      field: fieldKey,
      order: "asc",
    };
    let isFilterJson = false;
    let newSort = [customSort];
    if (payload.hasOwnProperty("filters")) {
      if (typeof payload.filters == "string") {
        payload.filters = JSON.parse(payload.filters);
        isFilterJson = true;
      }
      let foundSorting = payload.filters.sort.filter(
        (x) => x.field == fieldKey
      );

      for (let i in payload.filters.sort) {
        if (payload.filters.sort[i].field != fieldKey) {
          newSort.push(payload.filters.sort[i]);
        }
      }
      payload.filters.sort = newSort;
    } else if (payload.sort) {
      if (typeof payload.sort == "string") {
        payload.sort = JSON.parse(payload.sort);
      }
      let foundSorting = payload.sort.filter((x) => x.field == fieldKey);
      for (let i in payload.sort) {
        if (payload.sort[i].field != fieldKey) {
          newSort.push(payload.sort[i]);
        }
      }
      payload.sort = newSort;
    }

    if (forEvent == "BEFORE_AUTOCOMPLETE_EXECUTED") {
      // payload.sort = [customSort, {"field":"createdAt","order":"desc"}];
      payload.sort = [customSort, {"field":"sellingPrice","order":"desc"}];
    }

    //  payload.sort = [customSort];
  },
};


window.addEventListener("onWizzyScriptLoaded",function(){
  // console.log("===============wizzyLoaded==============");
  
  let isLocationLoaded = false;
  let cachedBreadCurmbs = $("#wizzy-bread-crumbs").html();
  let cachedBreadCurmbsLoaded = false;
  
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, (payload) => {
      //Custom Logic
      // console.log("VIEW_RENDERED called");
      let facetScrollId = setInterval(function() {
        if(window.wizzySelectedFacetValue) {
          let x = document.querySelector(".wizzy-facet-list-item[title=\"" + window.wizzySelectedFacetValue + "\"]");
          // console.log(window.wizzySelectedFacetValue, "<====values");
          window.wizzySelectedFacetValue = null;
          if(x) {
            setTimeout(function() { x.scrollIntoView({"behavior": "smooth", "block": "center"}) }, 800);
          }
          clearInterval(facetScrollId);
        }
      }, 40);

      setTimeout(function() {
        // console.log("<======clear by abcd");
        clearInterval(facetScrollId);
      }, 2000);



      // Pleases add geocode here
      

      if(payload.data.api === "filter") {
        window.wizzySelectedFacetTrue = true;
      }
      
      // let zipCode = window.localStorage.getItem("wizzy-last-zip");
      // console.log("TYPE ZIP => ", zipCode, typeof zipCode);
      
      // if(typeof zipCode !== 'undefined' && zipCode !== null && !self.isLocationLoaded && payload.data.api === "filter") {
      //   self.isLocationLoaded = true;
      //   self.updateDomBeforeZipCodeResults();
      //   self.HandleZipCodeAndRadius(payload);
      // }else if(typeof zipCode !== 'undefined' && zipCode !== null && payload.data.api === "search") {
      //   self.isLocationLoaded = true;
      //   self.updateDomBeforeZipCodeResults();
      //   self.HandleZipCodeAndRadius(payload);
      // }

      // console.log(window.wizzyGeoCodeFilter.getCurrentZip(), "<=======CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC");
      let searchOrFilter = ["search", "filter"];
      if(typeof window.wizzyPincodeApplyButtonClicked !== 'undefined' && window.wizzyPincodeApplyButtonClicked === true) {
          window.wizzyPincodeApplyButtonClicked = false;
          let filterApplyButton = document.querySelector(".wizzy-mobile-apply-filter-wrapper");
          if(filterApplyButton) {
              filterApplyButton.click();  
          }  
      }
      
      if (payload.data.api == "search" || payload.data.api == "filter") {
            window.wizzyGeoCodeFilter.init();
      }
      
      if (payload.data.api == "filter" && !isLocationLoaded && window.wizzyConfig.common.isOnCategoryPage && window.location.search.length === 0) {
          isLocationLoaded = true;
          // window.wizzyGeoCodeFilter.makeApiCall();
          setTimeout(function() {
            if(!((window.location.pathname == "/collections/tampa" && window.location.search == "")|| (window.location.pathname == "/collections/houston" && window.location.search == "")|| (window.location.pathname == "/collections/dallas" && window.location.search == "") || (window.location.pathname == "/collections/miami" && window.location.search == "") || (window.location.pathname == "/collections/san-antonio" && window.location.search == "")  || (location.pathname.includes('/collections/store_')) || (location.pathname.includes('/collections/Store_')) || (location.search.includes("product_market_tags[]=") && location.search.includes("product_category_tags[]=")))) {
              window.wizzyGeoCodeFilter.executeFilterApi(false);
              // console.log("Geocode filter api called");
            }
          }, 500);
      }

      if (payload.data.api == "search" || payload.data.api == "filter") {
        if (location.search.includes("product_market_tags[]=") || location.search.includes("product_category_tags[]=")) {
              const viewAllInventory = document.querySelector(".wizzy-no-store-all-inventory");
              if(viewAllInventory)  viewAllInventory.click();
            }

            if (payload.data.api =="search") {
              window.wizzyGeoCodeFilter.executeFilterApi(false);
            }

            // console.log(wizzyGeoCodeFilter.getCurrentZip(), "<=======ABBBBBBBBBBBBBBBBBBBBBBBBBBBBB");
        
            if (window.wizzyGeoCodeFilter.getCurrentZip() && window.wizzyGeoCodeFilter.getCurrentZip().length == 5) {
                $("body").removeClass("wizzy-dont-have-pincode");
                $("body").addClass("wizzy-have-pincode");
                if (location.pathname.includes('/collections/store_') || location.pathname.includes('/collections/Store_')) {
                  let allInvetBtn = document.querySelector(".wizzy-no-store-all-inventory");
                  if (allInvetBtn) {
                      allInvetBtn.click();
                  }
                }
            } else {
                // console.log("Class added");
                $("body").addClass("wizzy-dont-have-pincode");
                if ($('body').hasClass('wizzy-ignore-zipcode-info')) {
                  $("html").removeClass("wizzy-scroll-disabled");
                }else {
                  $("html").addClass("wizzy-scroll-disabled");
                }
                if (location.pathname.includes('/collections/store_') || location.pathname.includes('/collections/Store_')) {
                  let allInvetBtn = document.querySelector(".wizzy-no-store-all-inventory");
                  if (allInvetBtn) {
                      allInvetBtn.click();
                  }
                }
                $("body").removeClass("wizzy-have-pincode");
            }


            // payload.data.api !== "search" &&
            if ((!payload.data.response.payload.filters?.attributes?.hasOwnProperty('product_inventory_sources_ids') || typeof payload.data.response.payload.filters?.attributes === "undefined")) {

                  let allTheFacets = payload.data.response.payload.facets;
                  let allTheFacetsLen = allTheFacets.length;
                  // let dataToShowOnPage = [  "Texas",
                  //                           "Tennessee",
                  //                           "Alabama",
                  //                           "Pennsylvania",
                  //                           "Georgia",
                  //                           "Arizona",
                  //                           "Oregon",
                  //                           "Illinois",
                  //                           "Iowa",
                  //                           "Indiana",
                  //                           "Colorado",
                  //                           "Oklahoma",
                  //                           "Florida",
                  //                           "Wisconsin",
                  //                           "Minnesota",
                  //                           "Nevada",
                  //                           "Mississippi",
                  //                           "Arkansas",
                  //                           "Utah"
                  //                         ];

                  let dataToShowOnPage = [];
                
                  for(let i = 0 ; i < allTheFacetsLen ; i++) {
                    if(allTheFacets[i].key === "product_state_tags") {
                      let cityLen = allTheFacets[i].data.length;
                      for(let j = 0 ; j < cityLen; j++) {
                        dataToShowOnPage.push(allTheFacets[i].data[j].label);
                      }
                    }
                  }
              
                  // for(let i = 0 ; i < allTheFacetsLen ; i++) {
                  //   if(allTheFacets[i].key === "product_city_tags") {
                  //     let cityLen = allTheFacets[i].data.length;
                  //     for(let j = 0 ; j < cityLen; j++) {
                  //       dataToShowOnPage.push(allTheFacets[i].data[j].label);
                  //     }
                  //   }
                  // }
                  dataToShowOnPage.sort((a, b) => a.localeCompare(b));
                  if(dataToShowOnPage.length > 0) {
                    let domToGive = document.querySelector(".wizzy-no-store-found-data-to-add-wrapper");

                    if(domToGive && domToGive.childNodes.length === 0) {
                      dataToShowOnPage.forEach(function(item) {
                        let anchorTagEle = document.createElement('a');
                        anchorTagEle.style.color = "#007DB3";
                        anchorTagEle.style.textDecoration = "underline";
                        anchorTagEle.style.display = "block";
                        anchorTagEle.style.cursor = 'pointer';
                        anchorTagEle.style.width = 'max-content';
                        anchorTagEle.innerHTML = item;
                        anchorTagEle.setAttribute("data-filter-term", item.toLowerCase());
                        anchorTagEle.classList.add("wizzy-no-store-found-data-elements");
    
                        domToGive.appendChild(anchorTagEle);
                      });  
                    }
                    
                  }
              
                $("body").addClass("wizzy-has-not-available-stores");
                $("body").removeClass("wizzy-has-available-stores");
                $("body").removeClass("wizzy-hide-no-store-found");

            } else {
              if(payload.data.response.payload.filters?.attributes?.hasOwnProperty('product_inventory_sources_ids')) {
                
                $("body").addClass("wizzy-has-available-stores");
                $("body").removeClass("wizzy-has-not-available-stores");
                $("body").addClass("wizzy-hide-no-store-found");
                if(document.documentElement.clientWidth < 768) {
                  $("body").addClass("wizzy-hide-mobile-pincode-popup");
                }
              }else {
                $("body").addClass("wizzy-has-available-stores");
                $("body").removeClass("wizzy-has-not-available-stores");
                $("body").addClass("wizzy-hide-no-store-found");
              }
                
            }

        }
      
      if (
        window.wizzyConfig.search.configs.general.noOfProducts > payload.total
      ) {
        $("body").addClass("wizzyWithoutShorting");
      } else {
        $("body").removeClass("wizzyWithoutShorting");
      }
      if (!cachedBreadCurmbsLoaded) {
        cachedBreadCurmbsLoaded = true;
        $(".wizzy-search-summary-wrapper .wizzy-search-summary-container").html(
          cachedBreadCurmbs
        );
      }


      if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
        window._swat.initializeActionButtons(".wizzy-search-results");
      }
      wizzyCustomUtils.applyViewType();
      if(window.wizzyConfig.common.isOnCategoryPage && payload.data.api === "filter" && payload.data.response.payload.result.length == 0 ) {
        // console.log("Hiiiiiiiiii");
        const backButton = document.querySelector(".wizzy-back-to-collection-wrapper");
        if(backButton) backButton.style.display = "block";
      }   
      return payload;
    });
  wizzyCustomUtils.init();
});


// window.onWizzyScriptLoaded = function () {
//   console.log("===============wizzyLoaded==============");
//   wizzyCustomUtils.init();
// };
